import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import Api_Instance from "../../api/Api_Instance";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import Loader from "../../common/loader/Loader";
import { IoMdMailOpen } from "react-icons/io";
import { forgetpassword } from "../../api/endpoints";
import { setForgetPassword } from "../../redux/slice/Slice";



function ForgetPassword({ onClose, login, setLogin }) {
    const [isLogin, setIsLogin] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const api = Api_Instance.unAuth();

    const validateField = (name, value) => {
        const error = {};
        if (!value.trim()) {
            error[name] = `${name.replace(/_/g, " ")} is required`;
        } else if (name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                error[name] = "Enter a valid email address";
            }
        }
        return error;
    };

    const validate = (values) => {
        const error = {};
        Object.keys(values).forEach((key) => {
            const fieldErrors = validateField(key, values[key]);
            if (Object.keys(fieldErrors).length > 0) {
                error[key] = fieldErrors[key];
            }
        });
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLogin((prev) => ({ ...prev, [name]: value }));
        const fieldErrors = validateField(name, value);
        setErrors((prev) => ({ ...prev, ...fieldErrors }));
    };

    const handleSubmit = async () => {
        const fieldErrors = validate(login);
        setErrors(fieldErrors);

        if (Object.keys(fieldErrors).length === 0) {
            setLoading(true)
            try {
                const res = await api("POST", forgetpassword?.POST_FORGET_PASSWORD, login);
                if (res?.data?.status === true) {
                    dispatch(setForgetPassword({
                        email: false,
                        otp: true,
                        confirmpassword: false
                    }))
                    toast.success(res?.data?.message);
                }
            } catch (error) {
                toast.error(error?.response?.data?.error);
            } finally {
                setLoading(false)
            }
        } else {
            // toast.error("Please correct the errors before submitting.");
        }
    };
    const enterKye = (e) => {
        if (e.key === "Enter") {
            e.preventDefault()
            handleSubmit()
        }
    }
    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 backdrop-blur-sm xl:px-5 lg:px-5 md:px-5 px-5">
            <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
                <button
                    onClick={() => dispatch(setForgetPassword({
                        email: false,
                        otp: false,
                        confirmpassword: false
                    }))}
                    className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
                >
                    <FontAwesomeIcon icon={faTimes} size="lg" />
                </button>
                <div className="flex justify-center mb-[30px]">
                    <div
                        className="text-center mx-4 cursor-pointer"
                        onClick={() => setIsLogin(true)}
                    >
                        <h2
                            className={`text-xl font-medium mb-2 ${isLogin ? "text-text_color" : ""
                                }`}
                        >
                            Forgot Your Password?
                        </h2>
                        <p className="text-[#B3B3B3] text-[16px] mt-2 mb-[20px]">
                            Enter your email
                        </p>
                    </div>
                </div>
                <form className="max-w-md mx-auto">
                    <div className="mb-[50px] relative">
                        <label
                            className="block text-gray-700 text-sm font-bold mb-2 text-white"
                            htmlFor="username"
                        >
                            <IoMdMailOpen className="absolute left-3 top-[35px] text-gray-500 text-[24px]" />

                            Email
                        </label>
                        <input
                            className="appearance-none border rounded w-full py-2 pl-12 pr-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                            id="username"
                            type="text"
                            name="email"
                            value={login.email}
                            placeholder="Enter Email ID"
                            onChange={(e) => handleChange(e)}
                            onKeyPress={enterKye}
                        />

                        {errors.email && (
                            <p className="text-star_color text-sm">{errors.email}</p>
                        )}
                    </div>


                    {/* <div className="text-center mt-[50px] ">
                <button className="flex items-center gap-1 mx-auto">
                    <IoChevronBackOutline />
                    Back to Login
                </button>
            </div> */}
                </form>
                <div className="flex justify-center text-center mt-5">
                    <div className="bg-primaryColor rounded-md w-full [transition:all_.15s_ease-in-out] mb-[60px]">
                        <NavLink >
                            <button
                                className="text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline text-sm"
                                disabled={loading}
                                onClick={() => {
                                    handleSubmit()
                                    // (); focusedIndex == 0 
                                    //   && dispatch(setModal(true))
                                }}
                            >
                                {loading ? <Loader /> : "Next"}

                            </button>
                        </NavLink>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ForgetPassword